<template>
    <div class="min-h-screen  px-5 pb-20 lg:pb-52 bg-black bg-opacity-90 p-10">
        <div class="bg-black bg-opacity-20 rounded-lg p-5">
            <img
                class="mx-auto pt-5"
                v-bind:src="$page.props.white_label.data.logo_black"
                width="200"
            />
            <div v-if="error" class="text-center p-5">
                <div class="bg-white bg-opacity-5 rounded-full mx-auto mt-5 lg:mt-10 px-10 py-2 text-center max-w-sm">
                    <span class="text-white font-semibold">ME PARECE QUE O LINK<br>EXPIROU OU É INVÁLIDO</span>
                </div>
                <img class="mx-auto mt-5"
                     :src="require('../../../images/expired_access.png')"
                     width="250"/>
                <div class="mt-4 text-center">
                    <p class="text-gray-300 font-semibold text-sm md:text-base text-justify">
                        Caso já tenha concluído seu cadastro no aplicativo {{ mobileAppData.name }}, vá para a tela
                        inicial e insira suas credenciais para acessar o aplicativo.
                        Caso ainda não tenha essas credenciais, fale com a nossa equipe de atendimento através do
                        Whatsapp:
                    </p>
                    <div class="mt-10">
                        <div class="flex justify-center ">
                            <div class="px-1"><img :src="require('../../../images/whatsapp-brands.png')" width="30"/>
                            </div>
                            <div class="px-1"><a href="https://api.whatsapp.com/send/?phone=5511970234560"><span
                                class="text-2xl text-yellow-300 font-bold">(11) 97023-4560</span></a></div>
                        </div>
                    </div>
                </div>

            </div>
            <div v-else>
                <div class="bg-white bg-opacity-5 rounded-full mx-auto mt-5 lg:mt-10 px-10 py-2 text-center max-w-sm">
                    <span class="text-white text-xs md:text-base font-semibold">REALIZE SEU PRIMEIRO ACESSO<br>NO APLICATIVO <span
                        class="text-yellow-300">{{ mobileAppData.name }}</span></span>
                </div>

                <p class="mx-auto mt-5 text-sm md:text-base lg:mt-10 text-gray-300 max-w-3xl text-justify">
                    É necessário que o primeiro acesso seja realizado pelo
                    aplicativo {{ mobileAppData.name }} a partir de um dispositivo móvel iOS ou
                    Android. Acesse a loja de aplicativos abaixo, faça o download e instale o aplicativo.
                </p>

                <div class="grid grid-cols-4 gap-4">
                    <div class="col-span-4">
                        <a :href="mobileAppData.apple_store_url" v-if="userPlatform === 'iOS' || userPlatform === 'Unknown'">
                            <img class="mx-auto mt-5"
                                 :src="require('../../../images/app-store.png')"
                                 width="170"/>
                        </a>
                    </div>
                    <div class="col-span-4">
                        <a :href="mobileAppData.google_store_url" v-if="userPlatform === 'Android' || userPlatform === 'Unknown'">
                            <img
                                class="mx-auto mt-5"
                                :src="require('../../../images/google-play.png')"
                                width="175"
                            />
                        </a>
                    </div>
                </div>

                <div class="mx-auto text-center mt-5">
                    <p class="text-sm md:text-lg text-gray-300 font-semibold">Disponível no Brasil e EUA</p>
                    <div class="flex justify-center ">
                        <img class="mr-2" :src="require('../../../images/flag_brazil.png')" width="34"/>
                        <img :src="require('../../../images/flag_usa.png')" width="34"/>
                    </div>
                </div>

                <div class="my-5">
                    <p class="text-gray-300 font-semibold text-sm md:text-base text-justify lg:text-center">Caso já tenha o aplicativo
                        instalado, basta pular esta etapa e clicar no botão destacado abaixo para que o aplicativo
                        inicie o processo
                        de cadastro do seu usuário (lembrando que isso deve ser feito pelo seu dispositivo móvel).</p>
                    <div class="mx-auto mt-10 text-center">
                        <a class="mx-auto bg-yellow-300 hover:bg-yellow-400 text-black text-xs md:text-base font-bold py-3 px-3 md:px-6 rounded-full"
                           :href="`${mobileAppData.google_app_id}://app.2gopag.com/change-password/${this.code}`">
                            INICIAR PRIMEIRO ACESSO NO APLICATIVO
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";

export default {
    props: ["code", "error","mobile_settings"],
    components: {
        AppLayout,
        JetButton
    },
    data() {
        return {
            userPlatform: this.mobile_settings?.platform || "Unknown",
            mobileAppData: this.mobile_settings?.mobile_ib || {
                name: "2GO Bank",
                google_app_id: "com.ib2gopag.app",
                google_store_url: "https://play.google.com/store/apps/details?id=com.ib2gopag.app",
                apple_store_url: "https://apps.apple.com/tm/app/2go-bank/id1603338816",
            }
        };
    }
};
</script>
